import { UPDATEWORKSPACE_FAIL, UPDATEWORKSPACE_SUCCESS } from '../actionTypes';

const initialState = {
	user: null
};

const updateWorkspaceReducer = (state = initialState, action) => {
	switch (action.type) {
		case UPDATEWORKSPACE_SUCCESS:
			return {
				...state,
				isLoggedIn: true,
				user: action.payload.user,
				expenseVoucherFile: action.payload.expenseVoucherFile || null,
			};
		case UPDATEWORKSPACE_FAIL:
			return {
				...state,
				isLoggedIn: false,
				user: null,
				expenseVoucherFile: null,
			};
		default:
			break;
	}
	return state;
};

export default updateWorkspaceReducer;
